import {createPromisedAction} from '/util/action.util';

export const POPOVER_CLOSE: string = 'POPOVER_CLOSE';
export const POPOVER_OPEN: string = 'POPOVER_OPEN';

export const closePopover = createPromisedAction(POPOVER_CLOSE);
export const openPopover = createPromisedAction(POPOVER_OPEN);
